import React from 'react';
import ShareRewindSlideBase from './ShareRewindSlideBase';
import CustomCruiseIcon from '../CustomCruiseIcon';

interface ShareRewindTitleSlideProps {
  year: number;
}

const ShareRewindTitleSlide = React.forwardRef<HTMLDivElement, ShareRewindTitleSlideProps>(
  ({ year }, ref) => {
    return (
      <ShareRewindSlideBase ref={ref} year={year}>
        <div className="flex flex-col items-center justify-center h-full text-center">
          <div className="mb-8">
            <CustomCruiseIcon size={120} className="text-white" />
          </div>
          <div className="text-8xl font-bold text-white leading-none mb-6">
            Cruising Along
          </div>
          <div className="text-9xl font-bold text-white leading-none mb-4">
            Rewind {year}
          </div>
          <div className="text-6xl text-white/90 font-medium">
            Your Year in Review
          </div>
        </div>
      </ShareRewindSlideBase>
    );
  }
);

ShareRewindTitleSlide.displayName = 'ShareRewindTitleSlide';

export default ShareRewindTitleSlide;

